export const DELETE_MAKERS = "DELETE_MAKERS";
export const deleteMakersAction = (makers) => {
    return {
        type: "DELETE_MAKERS",
        payload: makers
    }
}

export const FETCH_MAKERS = "FETCH_MAKERS";
export const fetchMakersAction = (makers) => {
    return {
        type: "FETCH_MAKERS",
        payload: makers
    }
}

export const INIT_MAKERS = "INIT_MAKERS";
export const initMakersAction = () => {
    return {
        type: "INIT_MAKERS",
        payload: null
    }
}
